import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_URL || 'http://localhost:8000/api';

class AdminService {
  constructor() {
    this.axios = axios.create({
      baseURL: API_URL,
      withCredentials: true,
    });

    this.axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  async getAllUsers() {
    const response = await this.axios.get('/admin/users');
    return response.data;
  }

  async updateUserRole(userId, role) {
    const response = await this.axios.put(`/admin/users/${userId}/role`, { role });
    return response.data;
  }

  async createUser(payload) {
    const response = await this.axios.post('/admin/users', payload);
    return response.data;
  }

  async updateUserStatus(userId, isActive) {
    const response = await this.axios.put(`/admin/users/${userId}/status`, { isActive });
    return response.data;
  }

  async softDeleteUser(userId) {
    const response = await this.axios.delete(`/admin/users/${userId}`);
    return response.data;
  }

  async resetUserPassword(userId, newPassword, confirmPassword) {
    const response = await this.axios.post(`/admin/users/${userId}/reset-password`, {
      newPassword,
      confirmPassword,
    });
    return response.data;
  }

  async enableFeatureForUser(userId, feature) {
    const response = await this.axios.post(`/admin/users/${userId}/features`, { feature });
    return response.data;
  }

  async disableFeatureForUser(userId, feature) {
    const response = await this.axios.delete(`/admin/users/${userId}/features/${feature}`);
    return response.data;
  }

  async enableFeatureForAll(feature) {
    const response = await this.axios.post('/admin/features/enable-all', { feature });
    return response.data;
  }

  async disableFeatureForAll(feature) {
    const response = await this.axios.post('/admin/features/disable-all', { feature });
    return response.data;
  }

  async getFeatures() {
    const response = await this.axios.get('/admin/features');
    return response.data;
  }

  async getFeatureStats() {
    const response = await this.axios.get('/admin/features/stats');
    return response.data;
  }
}

export default new AdminService();
